export default function contentToReadTimeString(content: string): string {
  return `${Math.ceil((content || "").length / 500)} Minute Read`
}
